const subscriptions = new Map();

const normalizePayload = (payload) => {
  if (typeof payload !== 'string') return payload;
  try {
    return JSON.parse(payload);
  } catch {
    return null;
  }
};

const notifyListeners = (entry, callbackName, payload) => {
  entry.listeners.forEach((listener) => listener[callbackName]?.(payload));
};

const releaseEntry = (key, entry) => {
  try {
    entry?.subscription?.unsubscribe?.();
  } catch {}
  subscriptions.delete(key);
};

export const subscribeToRoomInboxEvents = (cable, accountId, handlers = {}) => {
  if (!cable?.subscriptions?.create || !accountId) return () => {};

  const key = String(accountId);
  let entry = subscriptions.get(key);
  if (entry && entry.cable !== cable) {
    releaseEntry(key, entry);
    entry = null;
  }

  if (!entry) {
    entry = {
      cable,
      listeners: new Set(),
      subscription: null,
    };
    entry.subscription = cable.subscriptions.create(
      { channel: 'RoomInboxEventsChannel' },
      {
        connected: () => notifyListeners(entry, 'onConnected'),
        disconnected: () => notifyListeners(entry, 'onDisconnected'),
        received: (payload) => {
          const data = normalizePayload(payload);
          if (!data || data.type !== 'room_inbox_changed') return;
          notifyListeners(entry, 'onReceive', data);
        },
      },
    );
    subscriptions.set(key, entry);
  }

  const listener = {
    onConnected: handlers.onConnected || null,
    onDisconnected: handlers.onDisconnected || null,
    onReceive: handlers.onReceive || null,
  };
  entry.listeners.add(listener);

  return () => {
    const current = subscriptions.get(key);
    if (!current) return;
    current.listeners.delete(listener);
    if (current.listeners.size === 0) releaseEntry(key, current);
  };
};

export const releaseRoomInboxEventsSubscription = (accountId) => {
  if (!accountId) return;
  const key = String(accountId);
  const entry = subscriptions.get(key);
  if (entry) releaseEntry(key, entry);
};
